import { render, staticRenderFns } from "./ConfigPuzzleImg.vue?vue&type=template&id=716f0b84&scoped=true&"
import script from "./ConfigPuzzleImg.vue?vue&type=script&lang=js&"
export * from "./ConfigPuzzleImg.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPuzzleImg.vue?vue&type=style&index=0&id=716f0b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f0b84",
  null
  
)

export default component.exports